export const addZeroToLeft = number => {
  return number < 10 ? `0${number}` : number
}

export const formatPrice = price => {
  const parsedPrice = parseFloat(price)
  return isNaN(parsedPrice) ? '-' : `${parsedPrice.toFixed(2)}€`
}

export const delay = msecs => new Promise(resolve => setTimeout(resolve, msecs))

export const isNilOrEmpty = x => {
  if (x === null || x === undefined) {
    return true
  }

  if (Array.isArray(x) || typeof x === 'string' || x instanceof String) {
    return x.length === 0
  }

  if (typeof x === 'object') {
    return Object.keys(x).length === 0
  }

  return false
}

export const generateRandomKey = () => `${+new Date()}-${Math.random()}`

//source: https://www.joshwcomeau.com/snippets/javascript/debounce/
export const debounce = (callback, wait) => {
  let timeoutId = null
  return (...args) => {
    window.clearTimeout(timeoutId)
    timeoutId = window.setTimeout(() => {
      callback.apply(null, args)
    }, wait)
  }
}
